var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMcAfeeLogo20171(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 39,
    viewBox: "0 0 190 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_13306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.352 24.652L90.4215 21.7363L90.0693 22.3106C88.9688 24.0777 87.428 24.9612 85.535 24.9612C82.2774 24.9612 79.8561 22.4873 79.8561 19.2624C79.8561 15.9934 82.3214 13.5636 85.535 13.5636C87.472 13.5636 88.8807 14.403 90.0693 16.2142L90.4215 16.7885L95.352 13.8729L94.9118 13.2544C92.5346 9.80861 89.497 8.17407 85.491 8.17407C77.9632 8.17407 73.9131 13.9171 73.9131 19.3066C73.9131 24.6962 77.9632 30.4391 85.491 30.4391C89.3209 30.4391 92.9308 28.4954 94.9118 25.3146L95.352 24.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0874 30.3506H101.867L103.892 25.3145H114.061L116.086 30.3506H122.91L110.759 0.884766H104.684L106.313 4.81648L95.0874 30.3506ZM109.042 12.5032L111.772 19.439H106.225L109.042 12.5032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.727 30.3951H131.67V17.142H135.544V11.5758H131.67V8.96936C131.67 7.82076 132.419 6.62798 133.827 6.62798C134.576 6.62798 135.06 6.76055 135.5 6.93722L136.161 7.20229L138.626 1.76854L137.966 1.54766C136.865 1.10588 135.324 0.929199 134.224 0.929199C131.538 0.929199 129.293 1.81273 127.796 3.49144C126.476 4.94928 125.727 6.9814 125.727 9.23442V11.6199H123.086V17.1862H125.727V30.3951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8883 13.387V30.3508H71.3596V0.708252L58.6371 10.3388L45.8706 0.708252V30.3067L52.3419 30.3508V13.387L58.6371 18.0697L64.8883 13.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.971 8.17407C141.488 8.17407 137.438 13.8729 137.438 19.2624C137.438 24.652 141.488 30.3508 148.971 30.3508C152.405 30.3065 155.619 28.7604 158.128 25.889L153.286 23.2383C152.053 24.5195 150.512 25.1821 148.839 25.1821C146.374 25.1821 144.217 23.5476 143.645 21.3829H159.845V19.9251C159.889 11.8408 153.506 8.21824 148.971 8.17407ZM143.777 16.5676C144.569 14.5355 146.242 13.3869 148.399 13.3869C150.6 13.3869 152.317 14.5355 153.198 16.6118L143.777 16.5676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.316 8.21802C165.832 8.21802 161.782 13.9168 161.782 19.3064C161.782 24.6959 165.832 30.3947 173.316 30.3947C176.749 30.3505 179.963 28.8044 182.472 25.9329L177.63 23.2823C176.397 24.5634 174.856 25.2261 173.184 25.2261C170.718 25.2261 168.561 23.5915 167.989 21.4269H184.189V19.969C184.233 11.8847 177.85 8.21802 173.316 8.21802ZM168.121 16.5674C168.913 14.5353 170.586 13.3425 172.743 13.3867C174.944 13.3867 176.661 14.5353 177.542 16.6116L168.121 16.5674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.441 7.20215H185.95V7.68807H184.938V10.3387H184.409V7.68807H183.441V7.20215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.346 7.20215H187.095L187.975 9.63185L188.812 7.20215H189.56V10.3387H189.032V7.90899L188.151 10.3387H187.711L186.83 7.90899V10.3387H186.302V7.20215H186.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3439 8.08551L1.36377 0.663818V30.1739L17.3439 37.5955V30.3506L7.92311 25.9771V10.957L17.3439 15.3305V8.08551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 8.08551L33.3679 0.663818V30.1739L17.3438 37.5955V30.3506L26.8086 25.9771V10.957L17.3438 15.3305V8.08551Z",
    fill: "#FFFAF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_13306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189.076,
    height: 37.8153,
    fill: "white",
    transform: "translate(0.923828 0.222168)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcAfeeLogo20171);
export default __webpack_public_path__ + "static/media/McAfee_logo_(2017) 1.24786393f900f39d57cb5e1dbb1c5ca1.svg";
export { ForwardRef as ReactComponent };